import React from 'react';
import { findLabel, SLIDE_TYPES } from '../labels';
import type { PresentationSlide } from '../types';

interface Props {
  slide: PresentationSlide | null;
}

/** Korte tekstpreview van de volgende slide -- alleen het slide-type en het
 * begin van de publieke inhoud, nooit privénotities. */
export default function NextSlidePreview({ slide }: Props) {
  if (!slide) return null;
  return (
    <p className="text-xs text-slate-400">
      Volgende: {findLabel(SLIDE_TYPES, slide.slide_type)}{slide.content ? ` · ${slide.content.slice(0, 60)}` : ''}
    </p>
  );
}
